export default __webpack_public_path__ + "images/openai-logomark.d269933a7807a805fc58d74b7c714ac4.png";